import { useEffect, useState } from 'react';

/**
 * `true` finche' l'elemento e' (anche in parte) nel viewport. Senza `IntersectionObserver` (jsdom, WebView vecchie) o se lancia, vale
 * «in vista»: meglio un video acceso di una figura che non parte mai. Lo usa il banner per fermare il video quando la figura esce di scena.
 * Si passa l'elemento come STATO (`useState` + ref a callback): la figura del banner compare solo quando l'avatar e' arrivato.
 */
export function useInVista(el: Element | null): boolean {
  const [inVista, setInVista] = useState(true);
  useEffect(() => {
    if (!el || typeof IntersectionObserver === 'undefined') return;
    let obs: IntersectionObserver;
    try {
      obs = new IntersectionObserver((voci) => {
        const ultima = voci[voci.length - 1];
        if (ultima) setInVista(ultima.isIntersecting);
      });
      obs.observe(el);
    } catch {
      return;
    }
    return () => obs.disconnect();
  }, [el]);
  return inVista;
}
